import FormFields from "./modules/FormFields";
import Menu from "./modules/Menu";
import Animations from "./modules/Animations";
import Tabs from "./modules/Tabs";
import RelatedProductsSlider from "./modules/RelatedProductsSlider";
new Menu();
new FormFields();
// declare global window localize_script
window.localize_script = localize_script;
// Remove no-js class
document.querySelector('html').classList.remove('no-js');
// Init tabs
const tabGroups = document.querySelectorAll('.tabs');
tabGroups.forEach((tabGroup) => new Tabs(tabGroup));
// Init gsap animations
new Animations();
const relatedProductsSlider = document.querySelectorAll('[data-related-products-slider]');
relatedProductsSlider.forEach((block) => new RelatedProductsSlider(block));
